import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { MONTHS_WITHOUT_ALL } from '../../../../utils/courseIncome/constaints';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { attendanceViewCroTableHead } from './utils/tableHeaders';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import DailyView from './components/DailyView';

export default function AttendanceViewCro() {
  // normal variable
  const dispatch = useDispatch();

  // Redux State-------------------------------------------------------------
  /* const loading = useSelector((state) => state.crdMigration.studentSessionAnalyticsTable.loading);
  const studentSessionAnalyticsTable = useSelector((state) => state.crdMigration.studentSessionAnalyticsTable.data);
  const meta = useSelector((state) => state.crdMigration.studentSessionAnalyticsTable.meta); */
  //--------------------------------------------------------------------------

  // react state
  const [month, setMonth] = useState({ id: dayjs().month() + 1, value: '' });
  const [year, setYear] = useState(dayjs().year());

  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: 'asc' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });

  //---------- DispatchParams ---------------------------------
  const dispatchParams = useMemo(
    () => ({
      year,
      month: month?.id,
      page: tableState?.page,
      limit: tableState?.pageSize,
      search: tableState?.search,
      sortBy: tableState?.sort?.field,
      sortOrder: tableState?.sort?.direction,
    }),
    [year, month, tableState?.page, tableState?.search, tableState?.sort, tableState?.pageSize],
  );

  //---------* =-=-=-==-=--=-=-=-=- *---------------------------

  //-------------- Table Fetch ------------------------------
  /*  useEffect(() => {
    dispatch(getStudentSessionAnalyticsTable(dispatchParams));
  }, [dispatchParams, dispatch]); */
  //-------------* Table Fetch *-----------------------------

  // table Head
  const tableHead = useMemo(() => attendanceViewCroTableHead({ setModalState }), []);

  // Global_Dialogue --------------------------------------------------------

  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;
    else {
      setModalState({
        actionKey,
        row,
      });
    }
  }, []);

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'Daily View',
        title: 'Daily View',
        maxWidth: 'md',
        render: ({ row }) => <DailyView />,
      },
    ],
    [],
  );

  const activeConfig = useMemo(() => {
    if (!modalState.actionKey || !modalState.row) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState.actionKey, modalState.row]);

  // ---------------------------------------------------

  const rows = [
    {
      id: 1,
      sl_no: 1,
      student: 'Arjun Nair',
      trainer: 'Rahul Das',
      course: 'Foundation',
      day_1: 'P',
      day_2: 'P',
      day_3: 'A',
      day_4: 'P',
      day_5: 'P',
      day_6: 'P',
      day_7: 'A',
      day_8: 'P',
      day_9: 'P',
      day_10: 'P',
      day_11: 'P',
      count: 9,
    },
    {
      id: 2,
      sl_no: 2,
      student: 'Meera Krishnan',
      trainer: 'Anjali Menon',
      course: 'Little Genie',
      day_1: 'P',
      day_2: 'P',
      day_3: 'P',
      day_4: 'P',
      day_5: 'P',
      day_6: 'P',
      day_7: 'P',
      day_8: 'P',
      day_9: 'P',
      day_10: 'P',
      day_11: 'P',
      count: 11,
    },
    {
      id: 3,
      sl_no: 3,
      student: 'Aditya Raj',
      trainer: 'Rahul Das',
      course: 'Speak Pro',
      day_1: 'A',
      day_2: 'A',
      day_3: 'P',
      day_4: 'P',
      day_5: 'P',
      day_6: 'A',
      day_7: 'P',
      day_8: 'P',
      day_9: 'A',
      day_10: 'P',
      day_11: 'P',
      count: 7,
    },
  ];

  return (
    <GlobalWrapper title={'Attandance View'}>
      <Stack gap={2}>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
          <GlobalSelectFieldWithoutFormikNew
            data={MONTHS_WITHOUT_ALL}
            keys={{
              itemId: 'id',
              itemValue: 'name',
            }}
            label={'Months'}
            selectedDetails={month}
            setChange={setMonth}
            sx={{
              maxWidth: { xs: '100%', sm: 180 },
            }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label={'Year'}
              views={['year']}
              onChange={(v) => setYear(v?.year() ? v?.year() : dayjs().year())}
              value={dayjs().year(year)}
              sx={{
                maxWidth: { xs: '100%', sm: 180 },
              }}
            />
          </LocalizationProvider>
        </Stack>
        <GlobalTable
          rowUniqueId="sl_no"
          headers={tableHead}
          tableState={tableState}
          setTableState={setTableState}
          loading={false}
          rows={rows}
          meta={{}}
          onButtonActionClick={handleButtonActionClick}
        />
        <GlobalDialog
          title={activeConfig?.title}
          open={Boolean(modalState?.actionKey)}
          setOpen={(val) => {
            if (!val) setModalState({ actionKey: '', row: null });
          }}
          closeButton={true}
          content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
          maxWidth={activeConfig?.maxWidth || 'md'}
          fullWidth={true}
        />
      </Stack>
    </GlobalWrapper>
  );
}
